// Copyright (c) 2020 Deere & Company

import './index.scss';

import AuthenticatedPage from '../../common/components/authenticated-page';
import FamilyBaseMachineGroupAvailability from './family-base-machine-group-availability';
import React from 'react';

function FamilyBaseMachineGroupAvailabilityPage () {

    return (
        <AuthenticatedPage className="atp-page atp-family-base-machine-group-availability-page">
            <FamilyBaseMachineGroupAvailability />
        </AuthenticatedPage>
    );

}
FamilyBaseMachineGroupAvailabilityPage.displayNAme = 'FamilyBaseMachineGroupAvailabilityPage';

export default FamilyBaseMachineGroupAvailabilityPage;
